var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C6.125 18.5 3.5 17 2.0625 14.5C0.625 12.0312 0.625 9 2.0625 6.5C3.5 4.03125 6.125 2.5 9 2.5C11.8438 2.5 14.4688 4.03125 15.9062 6.5C17.3438 9 17.3438 12.0312 15.9062 14.5C14.4688 17 11.8438 18.5 9 18.5ZM6.28125 7.6875V7.71875C6.15625 8.09375 6.34375 8.53125 6.75 8.6875C7.125 8.8125 7.5625 8.625 7.6875 8.21875L7.71875 8.1875C7.75 8.09375 7.84375 8.03125 7.9375 8.03125H9.75C10.0312 8.03125 10.25 8.21875 10.25 8.5C10.25 8.65625 10.1562 8.8125 10 8.90625L8.625 9.6875C8.375 9.8125 8.25 10.0625 8.25 10.3438V10.75C8.25 11.1875 8.5625 11.5 9 11.5C9.40625 11.5 9.71875 11.1875 9.75 10.7812L10.75 10.1875C11.3438 9.84375 11.75 9.1875 11.75 8.5C11.75 7.40625 10.8438 6.5 9.75 6.5H7.9375C7.1875 6.5 6.53125 6.96875 6.28125 7.6875ZM8 13.5C8 14.0625 8.4375 14.5 9 14.5C9.53125 14.5 10 14.0625 10 13.5C10 12.9688 9.53125 12.5 9 12.5C8.4375 12.5 8 12.9688 8 13.5Z",
    fill: "#6A48B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.912b39369fb254ee5758023c683cf2f0.svg";
export { ForwardRef as ReactComponent };